import { type NutritionalFactsProps } from '@src/components/NutritionalFacts/NutritionalFacts.props'

export const defaultHeaderContent = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        component: {
          name: 'Text',
          options: {
            text: '<p><span style="white-space-collapse: preserve;">AMOUNT PER SERVING</span><br></p>',
            style: 'Body XS - Medium weight',
          },
        },
        responsiveStyles: { large: { color: 'rgba(32, 132, 104, 1)', fontSize: '12px' } },
        meta: { previousId: 'builder-24433d505997421c91458063a5d84056' },
      },
    ],
    responsiveStyles: { large: { display: 'flex', flexDirection: 'row' } },
    meta: { previousId: 'builder-e27343bfa17c4b1b9db3c3136c929acb' },
  },
] as any

export const defaultHeaderColumn = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        component: {
          name: 'Text',
          options: { text: '<p>% DV</p>', style: 'Body XS - Medium weight' },
        },
        responsiveStyles: { large: { color: 'rgba(32, 132, 104, 1)' } },
        meta: { previousId: 'builder-cf25fb2438294382a8478fe8c80cdb50' },
      },
    ],
    responsiveStyles: {
      large: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' },
    },
    meta: { previousId: 'builder-471258bd0c37450cb2e01219cb0b1dd4' },
  },
] as any

export const defaultBodyContent = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        component: {
          name: 'Text',
          options: { text: '<p>Total sugars</p>', style: 'Body XS - Medium weight' },
        },
        meta: { previousId: 'builder-504c09b925e446d581193b1b4a4c76ea' },
      },
    ],
    responsiveStyles: { large: { display: 'flex', flexDirection: 'row' } },
    meta: { previousId: 'builder-d577887af6c44d15a6e1bf93ce3ae919' },
  },
] as any
export const defaultBodyColumn = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        component: { name: 'Text', options: { text: '<p>2%</p>', style: 'Body XS' } },
        meta: { previousId: 'builder-419be2c20c7c4cc9be41b392622b6d3e' },
      },
    ],
    responsiveStyles: {
      large: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' },
    },
    meta: { previousId: 'builder-2657255f91fd4893b87c21a36b1fcc6f' },
  },
] as any

const defaultBlocksRight = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    meta: { previousId: 'builder-e3ce7c606b7247f482bd986ebe90cae5' },
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: { previousId: 'builder-2eb9e3b381a94b5fb2771a5951216673' },
        children: [
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-b8d9b43e062a42de98f565bd01b79293' },
            component: {
              name: 'Text',
              options: { text: '<p>OTHER INGREDIENTS:</p>', style: 'Body XS - Medium weight' },
            },
            responsiveStyles: { large: { color: 'rgba(32, 132, 104, 1)', fontWeight: '600' } },
          },
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-355c8595494b4afa87a01c12d329d6d3' },
            component: {
              name: 'Text',
              options: {
                text: '<p>Organinc cane sugar, Citric acid, Stevia leaf extract, Green tea leaf extract, Natural flavors, Silica.</p>',
                style: 'Body XS',
              },
            },
            responsiveStyles: { large: { color: 'rgba(22, 24, 25, 1)' } },
          },
        ],
        responsiveStyles: {
          large: { gap: '0px', display: 'flex', flexDirection: 'column', alignItems: 'stretch' },
        },
      },
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: { previousId: 'builder-cd4242a3ad6a43068074e5641291cd85' },
        children: [
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-a3c3ad9bebb941f7a978e600b186b65f' },
            component: {
              name: 'Text',
              options: { text: '<p>ALLERGEN STATEMENT:</p>', style: 'Body XS - Medium weight' },
            },
            responsiveStyles: { large: { color: 'rgba(32, 132, 104, 1)', fontWeight: '600' } },
          },
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-6158f5772ce8489490ba0a91bfe333b0' },
            component: {
              name: 'Text',
              options: {
                text: '<p>This product is manufactured in a plant that also processes milk, soy, egg, fish, crustacean shellfish, tree nut, peanut, sesame, and wheat ingredients.</p>',
                style: 'Body XS',
              },
            },
            responsiveStyles: { large: { color: 'rgba(22, 24, 25, 1)' } },
          },
        ],
        responsiveStyles: {
          large: { gap: '0px', display: 'flex', flexDirection: 'column', alignItems: 'stretch' },
        },
      },
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: { previousId: 'builder-8f699f6acf584eb08fb04da0f8a56f48' },
        children: [
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-0c20d77f8c6042fa87610ccda7005c69' },
            component: {
              name: 'Text',
              options: { text: '<p>DIRECTIONS:</p>', style: 'Body XS - Medium weight' },
            },
            responsiveStyles: { large: { color: 'rgba(32, 132, 104, 1)', fontWeight: '600' } },
          },
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-3a7e22ea58e54bb5922fd63959c3ae95' },
            component: {
              name: 'Text',
              options: {
                text: '<p>Gently shake the container to loosen compressed powder. Mix 1 level scoop with 8 oz water until dissolved according to the RECOMMENDED USE below. Drink within 30 minutes before exercise. If sensitive to caffeine or other stimulants, start with 1 scoop. Do not exceed 2 scoops at one time, not more than twice daily, and at least 4 hours apart.</p>',
                style: 'Body XS',
              },
            },
            responsiveStyles: { large: { color: 'rgba(22, 24, 25, 1)' } },
          },
        ],
        responsiveStyles: {
          large: { gap: '0px', display: 'flex', flexDirection: 'column', alignItems: 'stretch' },
        },
      },
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: { previousId: 'builder-0d552cbf962f47a49f4382eac297e6dc' },
        children: [
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-1363c70d95a542e0a838277a9f3341dc' },
            component: {
              name: 'Text',
              options: { text: '<p>WARNING:</p>', style: 'Body XS - Medium weight' },
            },
            responsiveStyles: { large: { color: 'rgba(32, 132, 104, 1)', fontWeight: '600' } },
          },
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-5ef4ff61db724a8982bec089650911dd' },
            component: {
              name: 'Text',
              options: {
                text: '<p>This product is intended for use by healthy adults over 18 years of age. Do not consume this product if you are pregnant, breastfeeding, or if you are sensitive to Caffeine or Beta-alanine. Consult a healthcare professional prior to use if you have any medical condition or are taking any medication. Some people may also feel a mild tingling from beta-alanine. Limit use of other caffeine-containing products while taking this product, as too much caffeine may cause nervousness, irritability, sleeplessness, and occasionally, rapid heartbeat. Keep out of reach of children.</p><p>STORE IN A COOL, DRY PLACE.</p>',
                style: 'Body XS',
              },
            },
            responsiveStyles: { large: { color: 'rgba(22, 24, 25, 1)' } },
          },
        ],
        responsiveStyles: {
          large: { gap: '0px', display: 'flex', flexDirection: 'column', alignItems: 'stretch' },
        },
      },
    ],
    responsiveStyles: {
      large: {
        paddingBottom: '0px',
        gap: '16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        marginBottom: '0px',
        marginTop: '8px',
      },
    },
  },
] as any

const defaultBlocksSubHeading = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    meta: { previousId: 'builder-e59eac68bf6f4e6dadf69ff9e47aec97' },
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: { previousId: 'builder-048e37515c804434bb480d37360c5cf3' },
        children: [
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-c0e0d97f2c0e4a588904775d4ee62eee' },
            component: {
              name: 'Text',
              options: { text: '<p>Serving Size:</p>', style: 'Body SM' },
            },
            responsiveStyles: { large: { color: 'rgba(68, 70, 70, 1)', fontWeight: '400' } },
          },
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-ad615e2cb1bf45f8a60a95a1accc16a8' },
            component: {
              name: 'Text',
              options: { text: '<p>1 level scoop (6g)</p>', style: 'Body SM - Medium weight' },
            },
            responsiveStyles: { large: { color: 'rgba(32, 132, 104, 1)', fontWeight: '600' } },
          },
        ],
        responsiveStyles: { large: { display: 'flex', flexDirection: 'row', gap: '4px' } },
      },
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: { previousId: 'builder-0d0833ac0f9f4a178a520f34d259ec40' },
        children: [
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-04099be364984241bfed9d613d16f3f7' },
            component: {
              name: 'Text',
              options: { text: '<p>Serving Per Container: </p>', style: 'Body SM' },
            },
            responsiveStyles: { large: { color: 'rgba(68, 70, 70, 1)', fontWeight: '400' } },
          },
          {
            '@type': '@builder.io/sdk:Element',
            '@version': 2,
            meta: { previousId: 'builder-a59c73ba52884e6495e024d577304ec1' },
            component: {
              name: 'Text',
              options: { text: '<p>40</p>', style: 'Body SM - Medium weight' },
            },
            responsiveStyles: { large: { color: 'rgba(32, 132, 104, 1)', fontWeight: '600' } },
          },
        ],
        responsiveStyles: { large: { display: 'flex', flexDirection: 'row', gap: '4px' } },
      },
    ],
    responsiveStyles: {
      large: { paddingBottom: '0px', gap: '32px', display: 'flex', flexDirection: 'row' },
      small: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: '4px',
        marginTop: '8px',
      },
    },
  },
] as any

const defaultBlocksBottom = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    children: [
      {
        '@type': '@builder.io/sdk:Element',
        '@version': 2,
        meta: { previousId: 'builder-6532477fd378498087861bf4cf80ae9e' },
        component: {
          name: 'Text',
          options: {
            text: '<p>†Percent Daily Values are based on a 2,000 calorie diet.</p><p>**Daily Value (DV) not established.</p>',
            style: 'Body XS',
          },
        },
        responsiveStyles: {
          large: { color: 'rgba(112, 111, 115, 1)', fontWeight: '400', marginTop: '8px' },
        },
      },
    ],
    responsiveStyles: {
      large: {
        paddingBottom: '0px',
        gap: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      },
    },
    meta: { previousId: 'builder-f9892e660b34481d8a9ad22f459c2749' },
  },
] as any

export const NutritionalFactsDefaults = {
  previewAllItems: false,
  skipWrapper: false,
  singleColumn: false,
  heading: 'Supplement Facts',
  items: [
    {
      flavorName: 'Lemon',
      tableItems: [
        {
          columns: [
            {
              content: defaultHeaderColumn,
            },
            {
              content: defaultHeaderColumn,
            },
          ],
          content: defaultHeaderContent,
          cellType: 'header',
        },
        {
          columns: [
            {
              content: defaultBodyColumn,
            },
            {
              content: defaultBodyColumn,
            },
          ],
          content: defaultBodyContent,
          cellType: 'body',
        },
      ],
      blocksRight: defaultBlocksRight,
      blocksBottom: defaultBlocksBottom,
      blocksSubheading: defaultBlocksSubHeading,
      blocksTop: defaultBlocksRight,
    },
  ],
} satisfies NutritionalFactsProps
